import { checkGrantedAccess } from 'app/components/utils/utils';
import { AccessItem } from 'app/build-api';
import Statistics from './components/statistics';
import { NoAccess } from 'app/components/common/no-access/no-access';

export const StatisticsContainer = () => {
  return checkGrantedAccess(AccessItem.Statistics) ? <Statistics /> : <NoAccess />;
};
